import api from "./api";

export const authService = {
  login: (credentials) => api.post("/auth/login", credentials),
  // Genel kayıt yok: kullanıcılar yalnız yetkili akışlarda (onboarding/personel) oluşur.
  refresh: (refreshToken) => api.post("/auth/refresh", { refreshToken }),
  me: () => api.get("/accounts/me"),
  changePassword: (payload) => api.post("/accounts/change-password", payload),
  // Kasa ekranı şifresi
  setCashPassword: (payload) => api.post("/accounts/cash-password", payload),
  verifyCashPassword: (cashPassword) =>
    api.post("/accounts/cash-password/verify", { cashPassword }),
  // Davet (aktivasyon) akışı
  getInvitation: (token) => api.get(`/auth/invitations/${token}`),
  acceptInvitation: (payload) => api.post("/auth/accept-invitation", payload),
  // Şifremi unuttum akışı
  forgotPassword: (email) => api.post("/auth/forgot-password", { email }),
  getPasswordReset: (token) => api.get(`/auth/password-reset/${token}`),
  resetPassword: (payload) => api.post("/auth/reset-password", payload),
};
